import styled from 'styled-components';

export const LanguageFieldsContainer = styled.div<{
  $isVisible?: boolean;
}>`
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`;
